import React, { useState } from 'react';
import API_BASE_URL from './config';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      const data = await res.json();
      if (data.success) {
        // store user info in localStorage so login persists across refresh
        const user = data.user || { username };
        try { localStorage.setItem('authUser', JSON.stringify(user)); } catch (e) { /* ignore */ }
        if (onLogin) onLogin(user);
      } else {
        setError(data.message || 'Login failed');
      }
    } catch (err) {
      setError('Server error');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div dir="rtl" className="w-full max-w-md"> 
        <div className="card shadow-modern animate-in fade-in slide-in-from-bottom-5 duration-700">
          <div className="text-center mb-8">
            
            <h2 className="text-2xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
              تسجيل الدخول
            </h2>
            <p className="text-gray-600 mt-2">مرحباً بك في نظام إدارة النقل</p>
          </div>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">اسم المستخدم</label>
              <input 
                className="input-modern" 
                type="text" 
                value={username} 
                onChange={e => setUsername(e.target.value)} 
                required 
                placeholder="أدخل اسم المستخدم"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">كلمة المرور</label>
              <input 
                className="input-modern" 
                type="password" 
                value={password} 
                onChange={e => setPassword(e.target.value)} 
                required 
                placeholder="أدخل كلمة المرور"
              />
            </div>
            
            {error && (
              <div className="alert-error">
                {error}
              </div>
            )}
            
            <button className="btn-primary w-full text-lg" type="submit">
              دخول
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
